import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
function DetailPage() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const title = searchParams.get('title');

  return (
    <div className="" style={{ padding: '20px', textAlign: 'center' }}>
        <h1>{title}</h1>
        <div>
             <iframe
                src={id}
                width="80%"
                height="450"
                style={{ border: 'none' }}
                title="Baby Mini Mobile Game"
      />
      <div style={{ marginTop: '20px' }}>
         <Link to="/">Back to Game List</Link>
      </div>
     
        </div>
    
    </div>
  );
}

export default DetailPage;
